module.exports = __webpack_public_path__ + "static/media/menu_transactionDiscount_default.49465ee3.svg";